var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout-header" }, [
    _c("div", { staticClass: "layout-header-start" }, [
      _c("div", {
        staticClass: "layout-header-start-menu-icon",
        domProps: {
          innerHTML: _vm._s(
            _vm.isMenuMini ? _vm.iconMenuOpen : _vm.iconMenuClose
          )
        },
        on: { click: _vm.showMenu }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "layout-header-start-logo",
        domProps: { innerHTML: _vm._s(_vm.iconLogo) },
        on: { click: _vm.home }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "layout-header-middle" }, [_vm._t("middle")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "layout-header-end layout-header-end--desktop" }, [
      _c("div", {
        staticClass: "layout-header-end-ava",
        domProps: { innerHTML: _vm._s(_vm.iconAva) },
        on: { click: _vm.user }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "layout-header-end-exit",
        domProps: { innerHTML: _vm._s(_vm.iconExit) },
        on: { click: _vm.exit }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "layout-header-end layout-header-end--mobile" },
      [
        _c("q-btn", {
          attrs: { flat: "", round: "", dense: "", icon: "menu" },
          on: {
            click: function($event) {
              return _vm.$emit("mobile-menu-click", $event)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }